import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/movies';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[550px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20interior%20with%20dramatic%20red%20velvet%20curtains%20and%20golden%20stage%20lighting%2C%20luxurious%20atmosphere%2C%20warm%20amber%20spotlights%20creating%20atmospheric%20glow%2C%20elegant%20and%20grand%20cinema%20hall%2C%20rich%20dark%20tones%20with%20warm%20accents&width=1920&height=1080&seq=hero-cinema-main-bg&orientation=landscape"
          alt="97影院 - 电影大全免费在线观看"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-background-50"></div>
      <div className="absolute inset-0 bg-black/20"></div>

      <div className="relative z-10 w-full px-4 md:px-6 flex flex-col items-center text-center">
        <div className="max-w-3xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-50 leading-tight">
            <span className="text-primary-500">97影院</span> — 电影大全
            <br />
            免费在线观看
          </h1>
          <p className="mt-4 md:mt-6 text-base md:text-lg text-foreground-200 max-w-xl mx-auto leading-relaxed">
            最新电影、热播电影、经典电影一站尽享。动作片、喜剧片、科幻片、爱情片全覆盖，
            高清蓝光画质，播放流畅不卡顿。
          </p>
          <div className="mt-6 md:mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/action"
              className="px-8 py-3 bg-primary-500 text-foreground-50 font-semibold rounded-lg hover:bg-primary-600 transition-all duration-300 text-base whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line mr-2"></i>立即观影
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 border border-foreground-200/30 text-foreground-100 font-medium rounded-lg hover:bg-foreground-50/10 transition-all duration-300 text-base whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
          <div className="mt-8 md:mt-10 flex items-center justify-center gap-6 flex-wrap">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">{siteInfo.totalMovies.toLocaleString()}+</div>
              <div className="text-xs text-foreground-400 mt-1">电影资源</div>
            </div>
            <div className="w-px h-10 bg-foreground-200/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">{(siteInfo.dailyVisitors / 10000).toFixed(0)}万+</div>
              <div className="text-xs text-foreground-400 mt-1">日访问用户</div>
            </div>
            <div className="w-px h-10 bg-foreground-200/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">8K</div>
              <div className="text-xs text-foreground-400 mt-1">蓝光画质</div>
            </div>
            <div className="w-px h-10 bg-foreground-200/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">0</div>
              <div className="text-xs text-foreground-400 mt-1">卡顿播放</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-2xl text-foreground-300"></i>
      </div>
    </section>
  );
}